import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import authService from '../services/authService';
import companyService from '../services/companyService'
import { Navbar, Nav, Container, Button, NavDropdown } from "react-bootstrap";
import useRoles from '../hooks/useRoles';
import "./CustomNavbar.css";

const CustomNavbar = ({ isAuthenticated, setIsAuthenticated }) => {
  const [user, setUser] = useState(null);
  const [company, setCompany] = useState(null);
  const navigate = useNavigate();
  const { hasRole } = useRoles();

  const fetchUser = async () => {
    try {
      const res = await authService.get("/users/me");
      setUser(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchCompany = async () => {
    try {
      const res = await companyService.get("/company/my");
      setCompany(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (localStorage.getItem("access_token")) {
      fetchUser();
      fetchCompany();
    }
  }, [isAuthenticated]);

  const handleLogout = () => {
    localStorage.removeItem("access_token");
    setIsAuthenticated(false);
    navigate("/login");
    window.location.reload();
  };

  // Проверяем, есть ли доступ хотя бы к одному пункту меню
  const hasItemsAccess = hasRole('ReadItem') || hasRole('CreateItem') || hasRole('BatchCreateItem');
  const hasCdrAccess = hasRole('BatchCreateCdr') || hasRole('BatchUpdateCdr');
  const hasCategoriesAccess = hasRole('CreateCategory') || hasRole('UpdateCategory') || hasRole('DeleteCategory') || hasRole('ReadCategory');
  const hasMaterialsAccess = hasRole('CreateMaterial') || hasRole('UpdateMaterial') || hasRole('DeleteMaterial') || hasRole('ReadMaterial');
  const hasProductCardsAccess = hasRole('ReadProductCard') || hasRole('UploadProductCardPreview');

  return (
    <Navbar expand="lg" className="modern-navbar">
      <Container fluid>
        {/* Бренд или логотип */}
        <Navbar.Brand as={Link} to="/" className="company-brand">
          {company?.name}
        </Navbar.Brand>

        {/* Кнопка "бургер" для мобильных устройств */}
        <Navbar.Toggle aria-controls="basic-navbar-nav" />

        {/* Основное меню */}
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto main-nav">
            {/* Товары и макеты */}
            {hasItemsAccess && (
              <NavDropdown 
                title="Товары и макеты" 
                id="items-dropdown"
                className="nav-dropdown"
              >
                {hasRole('ReadItem') && (
                  <NavDropdown.Item as={Link} to="/items">
                    Список товаров
                  </NavDropdown.Item>
                )}
                {hasRole('CreateItem') && (
                  <NavDropdown.Item as={Link} to="/items/new">
                    Создать товар
                  </NavDropdown.Item>
                )}
                {hasRole('BatchCreateItem') && (
                  <NavDropdown.Item as={Link} to="/items/import">
                    Импорт товаров
                  </NavDropdown.Item>
                )}
                {hasCdrAccess && (
                  <NavDropdown.Item as={Link} to="/cdrfiles/import">
                    Импорт макетов
                  </NavDropdown.Item>
                )}
                {hasCategoriesAccess && (
                  <NavDropdown.Item as={Link} to="/categories">
                    Категории
                  </NavDropdown.Item>
                )}
                {hasMaterialsAccess && (
                  <NavDropdown.Item as={Link} to="/materials">
                    Материалы
                  </NavDropdown.Item>
                )}
                {hasProductCardsAccess && (
                  <NavDropdown.Item as={Link} to="/product-cards/preview">
                    Превью товаров
                  </NavDropdown.Item>
                )}
              </NavDropdown>
            )}

            {/* Заказы */}
            {hasRole('ReadOrders') && (
              <Nav.Link as={Link} to="/orders" className="nav-link-item">
                Заказы
              </Nav.Link>
            )}

            {/* Производство */}
            {(hasRole('ReadLayoutingOrders') || hasRole('ReadPrintingSheets') || 
              hasRole('ReadCuttingSheets') || hasRole('ReadPackagingOrders')) && (
              <NavDropdown 
                title="Производство" 
                id="production-dropdown"
                className="nav-dropdown"
              >
                {hasRole('ReadLayoutingOrders') && (
                  <NavDropdown.Item as={Link} to="/layouting">
                    Компоновка
                  </NavDropdown.Item>
                )}
                {hasRole('ReadPrintingSheets') && (
                  <NavDropdown.Item as={Link} to="/printing">
                    Печать
                  </NavDropdown.Item>
                )}
                {hasRole('ReadCuttingSheets') && (
                  <NavDropdown.Item as={Link} to="/cutting">
                    Резка
                  </NavDropdown.Item>
                )}
                {hasRole('ReadPackagingOrders') && (
                  <NavDropdown.Item as={Link} to="/packaging">
                    Упаковка
                  </NavDropdown.Item>
                )}
              </NavDropdown>
            )}

            {/* Склад */}
            {hasRole('ReadWarehouseItems') && (
              <Nav.Link as={Link} to="/warehouse" className="nav-link-item">
                Склад
              </Nav.Link>
            )}

            {/* Пользователи */}
            {hasRole('ReadAllUsers') && (
              <Nav.Link as={Link} to="/users" className="nav-link-item">
                Пользователи
              </Nav.Link>
            )}
          </Nav>

          {/* Правая часть навбара */}
          <Nav className="auth-nav">
            {localStorage.getItem("access_token") ? (
              <>
                <Navbar.Text className="me-3 user-name">
                  {user?.userName}
                </Navbar.Text>
                <Button 
                  variant="outline-danger" 
                  onClick={handleLogout}
                  className="logout-btn"
                >
                  Выйти
                </Button>
              </>
            ) : (
              <Nav.Link as={Link} to="/login" className="login-link">
                Войти
              </Nav.Link>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default CustomNavbar;